module.exports = __webpack_public_path__ + "static/media/banner3.3506e1f6.png";